import React, { useContext } from 'react'

interface PageContext {
  selectedNavIndex: number
  reportName: string
  siteUrl: string
}

const PageContext = React.createContext<PageContext>({} as any)

interface Props {
  data: PageContext
}

export const PageProvider: React.FC<Props> = ({ children, data }) => {
  return <PageContext.Provider value={data}>{children}</PageContext.Provider>
}

export const usePageContext = () => useContext(PageContext)
